import type { EtapaPipeline } from '@/lib/types'

type Stage = EtapaPipeline

interface PipelineProgressProps {
  /** `prospecto` no tiene paso propio acá: se dibuja como "aún no arrancó". */
  currentStage: Stage
  showLabels?: boolean
}

const stages: { key: Stage; label: string }[] = [
  { key: 'lead', label: 'Lead' },
  { key: 'contactado', label: 'Contactado' },
  { key: 'diagnostico', label: 'Diagnóstico' },
  { key: 'cotizado', label: 'Cotizado' },
  { key: 'negociacion', label: 'Negociación' },
  { key: 'cerrado', label: 'Cerrado' },
]

export default function PipelineProgress({ currentStage, showLabels = false }: PipelineProgressProps) {
  const currentIdx = stages.findIndex((s) => s.key === currentStage)

  return (
    <div className="pipeline-progress">
      {stages.map((stage, idx) => {
        let status: 'completed' | 'current' | 'future'
        if (idx < currentIdx) status = 'completed'
        else if (idx === currentIdx) status = 'current'
        else status = 'future'

        return (
          <div key={stage.key} className="pipeline-progress__step">
            {idx > 0 && (
              <div className={`pipeline-progress__line pipeline-progress__line--${idx <= currentIdx ? 'filled' : 'empty'}`} />
            )}
            <div className={`pipeline-progress__dot pipeline-progress__dot--${status}`} />
            {showLabels && (
              <span className={`pipeline-progress__label pipeline-progress__label--${status}`}>
                {stage.label}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
